import { useEffect, useState } from 'react';
import api from 'config/axiosConfig';
import { useParams } from 'react-router-dom';
import InfluenceCard from '../InfluenceCard';
import InfluenceProfileTabs from './InfluenceProfileTabs';
import { setDocumentTitle } from 'util/pageTitles';
import LoadingSkeleton from 'ui/LoadingSkeleton';
import { AxiosError } from 'axios';
import NotFoundPage from 'components/ResponsePages/404NotFoundPage';
import ServerErrorPage from 'components/ResponsePages/500ServerErrorPage';

const InfluenceProfile = () => {
  const { id } = useParams<{ id: string }>();
  const [influence, setInfluence] = useState<any>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    setDocumentTitle(`Influence - ${influence?.influencer_name} → ${influence?.influenced_name}`);
  }, [influence]);

  useEffect(() => {
    const fetchInfluence = async () => {
      if (isNaN(Number(id))) {
        setError('404: Failed to load influence profile. Please try again later.')
      } else {
      try {
        const response = await api.get(`/api/influences/id/${id}`);
        setInfluence(response.data);
      } catch (err) {
        if (err instanceof AxiosError && err.response?.status === 404) {
            setError('404: Failed to load influence profile. Please try again later.');
        } else {
            setError('Failed to load influence profile. Please try again later.');
        }
      }
    }
  };

    fetchInfluence();
  }, [id]);

  if (error) {
    return error.match(/404/) ? <NotFoundPage displayStyle={`page`} errorMessage={`Sorry, we couldn't find this influence.`} errorSubtext={`Double check the URL or try reloading the page.`} /> : <ServerErrorPage />
  }

  if (!influence) {
    return (
      <LoadingSkeleton count={1} height="h-80" className="mt-4" />
    );
  }

  return (
    <div className="py-0 relative">
      <div>
        <InfluenceCard
          influence={influence}
          isInfluenceProfilePage={true}
          isEntitySection={false}
        />
      </div>
      <InfluenceProfileTabs influence={influence} />
    </div>
  );
};

export default InfluenceProfile;